import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const TypeSelect = ({
  value,
  onChange,
  error,
  helperText,
  required = false,
  disabled = false,
  label,
  entities
}) => {
  return (
    <FormControl fullWidth required={required} error={!!error} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        variant="standard"
      >
        <MenuItem disabled value="">{label}</MenuItem>
        {entities?.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default TypeSelect;
